export * from './get-page-context';
export * from './add-page-context';
//# sourceMappingURL=index.js.map